const locale = {
	MAIL_LIST_ITEM_DEMS_ENABLED: 'DEM reception enabled',
	MAIL_LIST_ITEM_UNSUBSCRIBED: 'Unsubscribed',

	DETAILS_MAILS_FIELD_TITLE: 'Email address',
	DETAILS_MAILS_FIELD_DESCRIPTION: 'Description',
	DETAILS_MAILS_FIELD_TITLE_INDEX: 'Email address {index}',
	DETAILS_MAILS_FIELD_DESCRIPTION_INDEX: 'Description {index}',
	DETAILS_MAILS_FIELD_DEFAULT: 'Default',
	DETAILS_MAILS_FIELD_DEMS_ENABLED: 'Enables DEM reception',
	DETAILS_MAILS_FIELD_ITEM: 'Linked item',

	DIALOG_MAILS_ADD: 'Add Email Address'
};

export default locale;
